import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";

const EditarUsuario = ({ usuario, recargarLista }) => {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ ...usuario });

  const toggle = () => setModal(!modal);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      await axios.put(
        `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ActualizaUsuarios/${form.id}`,
        form,
        {
          auth: {
            username: "admin.icontec@icontec.org",
            password: "quAngEraMuSTerGerEDE",
          },
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      Swal.fire(
        "Actualizado",
        "El usuario fue actualizado exitosamente",
        "success",
      );
      toggle();
      recargarLista(); // Para actualizar la tabla
    } catch (error) {
      Swal.fire("Error", "No se pudo actualizar el usuario", "error");
      console.error(error);
    }
  };

  return (
    <>
      <Button color="info" size="sm" onClick={toggle}>
        Editar
      </Button>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Usuario</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Usuario</Label>
            <Input
              name="usuario"
              value={form.usuario}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label>Nombre</Label>
            <Input name="nombre" value={form.nombre} onChange={handleChange} />
          </FormGroup>
          <FormGroup>
            <Label>Dirección</Label>
            <Input
              name="direccion"
              value={form.direccion}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label>Municipio</Label>
            <Input
              name="municipio"
              value={form.municipio}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label>Teléfono</Label>
            <Input
              name="telefono"
              value={form.telefono}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label>Correo</Label>
            <Input name="correo" value={form.correo} onChange={handleChange} />
          </FormGroup>
          <FormGroup>
            <Label>Tipo Usuario</Label>
            <Input
              type="number"
              name="tipoUsuarioId"
              value={form.tipoUsuarioId}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label>Estado</Label>
            <Input name="estado" value={form.estado} onChange={handleChange} />
          </FormGroup>
          <FormGroup>
            <Label>Regional ID</Label>
            <Input
              type="number"
              name="regionalId"
              value={form.regionalId}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label>Taller ID</Label>
            <Input
              type="number"
              name="tallerId"
              value={form.tallerId}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label>Documento</Label>
            <Input
              name="documento"
              value={form.documento}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label>Contraseña</Label>
            <Input
              type="password"
              name="contrasena"
              value={form.contrasena}
              onChange={handleChange}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Guardar Cambios
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default EditarUsuario;
